import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Router} from '@angular/router';
import {CardModule} from 'primeng/card';
import {ButtonModule} from 'primeng/button'; // Import ButtonModule
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-agent-panel-metrics',
  standalone: true, // Make it standalone
  imports: [
    CardModule,
    ButtonModule, // Add ButtonModule here
    TranslateModule
  ],
  templateUrl: './agent-panel-metrics.component.html',
  styleUrls: ['./agent-panel-metrics.component.scss'], // Corrected property name
  changeDetection: ChangeDetectionStrategy.OnPush // Set Change Detection
})
export class AgentPanelMetricsComponent {

  constructor(
    private router: Router, // Corrected variable name
  ) {}

  goToMetrics(): void {
    // Navigate to the agent metrics page
    this.router.navigate(['/agent-metrics']);
  }
}
